import { takeLatest, call, put } from 'redux-saga/effects'
import { destroySessionBlock } from 'api/administration/blocks/Destroy'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../../actions/blocks.action'

async function getList(lessonId: number) {
  return lessonBlocksList(lessonId)
}

async function handleDestroySessionBlock(sessionBlockId: number) {
  return destroySessionBlock(sessionBlockId)
}

function* destroySessionBlockEffectSaga(action: any) {
  try {
    const {
      payload: { sessionBlockId, lessonId },
    } = action
    yield call(handleDestroySessionBlock, sessionBlockId)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    yield put(fromActions.Actions.setLoading(false))
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroySessionBlockWatcherSaga() {
  yield takeLatest(
    fromActions.DESTROY_SESSION_BLOCK,
    destroySessionBlockEffectSaga
  )
}
